import { render } from "./UploadReleaseModal.vue?vue&type=template&id=22ee0248"
import script from "./UploadReleaseModal.vue?vue&type=script&lang=js"
export * from "./UploadReleaseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__